import { createHomeService } from "../application/services/HomeService";
import { homeAdapter } from "../infra/adapters/home.adapter";
import { baseBuild } from "@/core/services/network/config/baseBuild";
import type { AppDispatch } from "@/app/store/store";

/**
 * Factory function to wire infrastructure -> application layer
 * This is where dependency injection happens
 * 
 * Uses RTK Query adapter for automatic caching and request deduplication
 */
export function homeBuild(dispatch: AppDispatch) {
  return baseBuild(
    (dispatch) => new homeAdapter(dispatch),
    (repo) => createHomeService(repo),
    dispatch
  );
}

